var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import logo from '../../assets/img/fairplay-logo.svg';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { fetchBalance as fetchBalanceAction } from '../../actions/creators/balance';
import { setActiveTab as setActiveTabAction, toggleSidebar as toggleSidebarAction, toggleUserMenu as toggleUserMenuAction } from '../../actions/creators/sidebar';
import { openBetSlipModal as openBetSlipModalAction } from '../../actions/coupon/creators/coupon';
import { openAuthModal as openAuthModalAction } from '../../actions/auth/creators/Login';
import { openRegistrationModal as openRegistrationModalAction } from '../../actions/auth/creators/Join';
import { signOut as signOutAction } from '../../actions/auth/creators/SignOut';
import Balance from './Balance';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleSidebar = function () {
            _this.props.toggleSidebarAction(_this.props.sidebarToggled);
        };
        _this.toggleUserMenu = function () {
            _this.props.toggleUserMenuAction(_this.props.userMenuToggled);
        };
        _this.openBetSlipModal = function () {
            _this.props.openBetSlipModalAction();
        };
        _this.openAuthModal = function () {
            _this.props.openAuthModalAction();
        };
        _this.openRegistration = function (e) {
            e.preventDefault();
            _this.props.openRegistrationModalAction();
        };
        return _this;
    }
    Header.prototype.render = function () {
        var _this = this;
        var _a = this.props, user = _a.user, betSlipsSize = _a.betSlipsSize, balance = _a.balance, intl = _a.intl, freebets = _a.freebets;
        var openBetSlipModal = this.openBetSlipModal;
        var openAuthModal = this.openAuthModal;
        var betSlipsProps = {
            betSlipsSize: betSlipsSize,
            openBetSlipModal: openBetSlipModal
        };
        var isAuthenticated = Object.keys(user).length > 0 && user.constructor === Object;
        return (_jsxs("header", __assign({ id: 'header' }, { children: [_jsx("div", { className: 'menu', onClick: this.toggleSidebar }), _jsx("div", __assign({ id: 'logo', onClick: function () { return _this.props.setActiveTabAction('live'); } }, { children: _jsx(Link, __assign({ to: '/' }, { children: _jsx("img", { src: logo, alt: '' }) })) })), _jsxs("div", __assign({ className: 'topmenu' }, { children: [!isAuthenticated &&
                            _jsxs("div", __assign({ className: 'auth-links' }, { children: [_jsx("button", __assign({ onClick: this.openRegistration }, { children: intl.formatMessage({ id: 'header.signin.join_title' }) })), _jsx("button", __assign({ onClick: openAuthModal }, { children: intl.formatMessage({ id: 'header.signin.title' }) }))] })), isAuthenticated &&
                            _jsxs("div", __assign({ className: 'user-links' }, { children: [_jsx(Link, __assign({ to: '/unsettled-bets', className: 'user-links__link' }, { children: intl.formatMessage({ id: 'profile.unsettled_bets' }) })), _jsx(Balance, __assign({ balance: balance, balanceLoad: this.props.balanceLoad, fetchBalanceAction: this.props.fetchBalanceAction, freebets: freebets, signOutAction: this.props.signOutAction, user: user, toggleUserMenu: this.toggleUserMenu, userMenuToggled: this.props.userMenuToggled }, betSlipsProps))] }))] }))] })));
    };
    return Header;
}(React.Component));
Header.propTypes = {
    sidebarToggled: PropTypes.bool.isRequired,
    userMenuToggled: PropTypes.bool.isRequired,
    fetchBalanceAction: PropTypes.func.isRequired,
    toggleSidebarAction: PropTypes.func.isRequired,
    betSlipsSize: PropTypes.number.isRequired,
    openBetSlipModalAction: PropTypes.func.isRequired,
    setActiveTabAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    balance: PropTypes.number,
    freebets: PropTypes.array
};
var mapStateToProps = function (state) { return ({
    user: state.auth.user,
    sidebarToggled: state.application.get('sidebarToggled'),
    userMenuToggled: state.application.get('userMenuToggled'),
    betSlipsSize: state.coupon.get('betSlips').size,
    balance: state.balance.value,
    balanceLoad: state.balance.isLoading,
    freebets: state.auth.freebets,
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    toggleSidebarAction: toggleSidebarAction,
    toggleUserMenuAction: toggleUserMenuAction,
    openBetSlipModalAction: openBetSlipModalAction,
    openAuthModalAction: openAuthModalAction,
    openRegistrationModalAction: openRegistrationModalAction,
    signOutAction: signOutAction,
    setActiveTabAction: setActiveTabAction,
    fetchBalanceAction: fetchBalanceAction
}, dispatch); };
Header = connect(mapStateToProps, mapDispatchToProps)(Header);
export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.jsx